import React from "react";
import Button from "../../../shared/components/atoms/button/button";
import { withBottomLine } from "../../../shared/utils/formatString";
import { siteUrl } from '../../../shared/utils/siteUrl';
import { getTextButtonKnowMore, getTextButtonYouHaveProblems } from "../../../utils/getPointMessages";
import { buttonClickTransversal } from "../../../utils/loyaltyDatalayer";
import GetPointsFor from '../get-points-for/get-points-for';
import "./section-how-get.scss";

const SectionHowGet = props => {

    const { setModalActive, isLogin, category = "mis_puntos" } = props;
    var contactLink = siteUrl + '/contactanos/#entrykey'
    const setModalAct = () => {
        buttonClickTransversal({
            category: withBottomLine(category),
            label: getTextButtonKnowMore(process.env.LOCALE)
        });

        setModalActive(<GetPointsFor
            setModalClose={() => setModalActive(null)}
        />)
    }
    const currentlyLocated = process.env.LOCALE.split("-")[1].toLowerCase();

    return (
        <div className={"f-section-how-get-container" + (isLogin ? ' f-how-get-back-login' : '')}>
            {!isLogin && <span className="f-curve-effect-how-get" />}
            <div className={"f-section-how-get-container-wrap"}>
                <div className="f-info-container">
                    <div className="f-info-container-title">
                        <h2>¿Cómo obtengo los puntos?</h2>
                    </div>
                    <div className="f-info-container-description">
                        <p>
                            Hay dos maneras de obtenerlos, la primera es con los códigos que {process.env.LOCALE === "es-AR" ? "encontrás" : "encuentras"} al respaldo de nuestros
                            productos Nosotras y la segunda, es interactuando con NosotrasOnline en los espacios que tenemos para
                            {
                                process.env.LOCALE === "es-AR" || process.env.LOCALE === "es-PY" || process.env.LOCALE === "es-UY" ? " vos." : " ti."
                            }
                        </p>
                    </div>
                    <div className="f-info-container-space">
                        <div className="f-btn-radius" onClick={(e) => { e.preventDefault(); setModalAct() }}>
                            <Button className="primary-pink" title={getTextButtonKnowMore(process.env.LOCALE)} />
                        </div>
                        <Button
                            className={"tertiary-pink" + (isLogin ? ' f-how-get-btn-login' : '')}
                            title={getTextButtonYouHaveProblems(process.env.LOCALE)}
                            onClick={(e) => {
                                e.preventDefault();
                                buttonClickTransversal({
                                    category: withBottomLine(category),
                                    label: getTextButtonYouHaveProblems(process.env.LOCALE)
                                });
                                window.location = contactLink
                            }}
                        />
                    </div>
                </div>
                <div className={"f-image-how-get --" + currentlyLocated}></div>
            </div>
            <span className={"f-curve-effect-end-section" + (isLogin ? ' f-back-curve-login' : ' f-back-curve')}>
                <span className="f-curve-effect-end-section-child" />
            </span>
        </div>
    )
}

export default SectionHowGet;
